import React from 'react';
import PropTypes from 'prop-types';
import DefaultType from "../../../../../../../../../Utils/Form/FormDynamic/Fields/DefaultType/DefaultType";
import {makeStyles} from "@material-ui/core";
const useStyles = makeStyles({
    container: {
        padding: '6px 6px 6px 15px',
        display: 'flex',
        alignItems: 'center',
        background: '#f6f6f6'
    }
})
const SelectWebEvent = ({eventIndex, onChangeEventComponent, events}) => {
    const classes = useStyles();
    return (
        <div className={classes.container}>
            <DefaultType
                setValue={onChangeEventComponent}
                values={events}
                labelStyles={{
                    width: 100,
                }}
                fieldStyles={{
                    width: 190
                }}
                field={{
                    path: `${eventIndex}.webEvent`,
                    label: "Web Event",
                    dropdown: "webEventDropdownList",
                    autofocus: true
                }}
            />
        </div>
    );
};

SelectWebEvent.propTypes = {
    eventIndex: PropTypes.number,
    onChangeEventComponent: PropTypes.func,
    events: PropTypes.array
};

export default SelectWebEvent;